<template>
    <div>
        <!-- 轮播图 -->
        <div class="header">
            <div class="header-tag">Cases</div>
            <!-- <div class="header-title">成功案例</div> -->
        </div>
        <!-- 成功案例 -->
        <div class="" style="margin: 60px 0;">
            <div class="">
                <div class="w">
                    <div class="flex-row flex-wrap justify-center">
                        <div class="flex-row flex-wrap">
                        <!-- <div @click="page(index)" class="cases-item flex-column align-center justify-center" :class="{ 'active': index == 0 }"
                            v-for="(item, index) in 18" style="border: none;">
                            <img :src="require('../../assets/img/customers_logo/客户logo1-0' + (index + 1) + '.png')" alt=""> 
                        </div> -->
                        <div @click="page(item.id)" class="cases-item flex-column align-center justify-center" 
                            v-for="(item, index) in customerData" style="border: none;">
                            <img :src="http.ipAddress+item.filePath"
                                 alt="">
                            <!-- <img :src="require('../../assets/img/customers_logo/未标题-1-0' + (index + 1) + '.png')" alt="">  -->
                        </div>
                    </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            customerData:[]
        }
    },
    methods: {
        page(index) {
            this.$router.push({path:'/casesDetail', query: {index}});
        }
    },
    mounted() {
        debugger
        let that=this;
        this.http.post("/api/FJ_Customer/GetAllCustomer",JSON.stringify({})).then((result)=>{
            debugger
           let objResult= eval(result);
           let iCode= objResult.code;
           if(iCode==0){
                that.customerData=objResult.data;
            }
        });
    }
}
</script>


<style scoped>
.header {
    background: url('../../assets/img/casesbanner.jpg') no-repeat;
    background-size: 100%;
}
.cases-item {
    width: 25%;
    padding: 10px;
    box-sizing: border-box;
    /* border: 1px solid #eee; */
}
.cases-item img {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    width: 200px;
}

.cases-item:nth-child(3n - 1) {
    border-left: none;
    border-right: none;
}

/* .products-item.active {
    border-color: #0AA00A;
} */
</style>


// WEBPACK FOOTER //
// src/views/cases/index.vue